import { useContext, useState } from 'react';
import { styles } from '../PedidosComponents';
import { makeStyles } from '@mui/styles';
import TextField from '@mui/material/TextField';
import { Select } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Proptypes from 'prop-types';
import Autocomplete from '@mui/material/Autocomplete';
import { UserContext } from '../../../context/UserContext';
import { PedidosContext } from '../../../context/PedidosContext';
import { MEDIO_DE_PAGO, PEDIDO_ESTADO } from '../../../constants';
import { useEffect } from 'react';
import { esPagoEnCredito, esPagoEnEfectivo, incluyeRecargo, pagoConOtrosMedios } from '../../../extras/utils';

const useStyles = makeStyles(styles);

function Totales({ selectedUser, notadCredito }) {
    const classes = useStyles();

    const { users, getUsers } = useContext(UserContext);
    const { ventaActual, modificarVenta, subtotal, totalDevuelto, recargo, setRecargo, totalFinal } = useContext(PedidosContext);
    const [userSearchInput, setUserSearchInput] = useState('');

    useEffect(() => {
        getUsers();
    }, [])

    // Calcula los valores cuando cambia el monto de pago con nota de credito
    useEffect(() => {
        const id = setTimeout(() => {
            let totalCobrable = Number(subtotal) - Number(totalDevuelto) - ventaActual.pagoNotaCredito;

            if (selectedUser?.identificador !== "9999" && selectedUser?.saldoCredito > 0 && esPagoEnCredito(ventaActual.medioDePago, selectedUser?.saldoCredito)) {
                let totalEnCredito = 0;
                if (selectedUser.saldoCredito > totalCobrable) {
                    totalEnCredito = totalCobrable;
                    totalCobrable = 0;
                }
                else {
                    totalCobrable -= selectedUser.saldoCredito;
                    totalEnCredito = selectedUser.saldoCredito
                }
                modificarVenta("pagoCredito", totalEnCredito);
            }

            if (esPagoEnEfectivo(ventaActual.medioDePago)) {
                modificarVenta("pagoEfectivo", totalCobrable);
            } else if (totalCobrable > 0 && pagoConOtrosMedios(ventaActual.medioDePago)) {
                modificarVenta("otros", totalCobrable);
            }
        }, 500);
        return () => clearTimeout(id);
    }, [ventaActual.pagoNotaCredito]);

    // UseEffect que se dispara al modificar el pago con credito
    useEffect(() => {
        if (ventaActual.pagoCredito === 0 && !selectedUser) return;
        const id = setTimeout(() => {
            let totalCobrable = Number(subtotal) - Number(totalDevuelto) - ventaActual.pagoNotaCredito;

            if (selectedUser?.identificador !== "9999" && selectedUser?.saldoCredito > 0 && esPagoEnCredito(ventaActual.medioDePago, selectedUser?.saldoCredito)) {
                let totalEnCredito = 0;
                if (selectedUser.saldoCredito > totalCobrable) {
                    totalEnCredito = totalCobrable;
                    totalCobrable = 0;
                    if (ventaActual.pagoEfectivo > 0) modificarVenta("pagoEfectivo", 0);
                    if (ventaActual.otros > 0) modificarVenta("otros", 0);
                }
                else {
                    totalCobrable -= selectedUser.saldoCredito;
                    totalEnCredito = selectedUser.saldoCredito
                }
                if (ventaActual.pagoCredito !== totalEnCredito) {
                    modificarVenta("pagoCredito", totalEnCredito);
                }
            } else if (selectedUser?.saldoCredito > 0 && selectedUser?.saldoCredito < ventaActual.pagoCredito) {
                modificarVenta("pagoCredito", selectedUser?.saldoCredito);
            }

            if (totalCobrable > 0 && esPagoEnEfectivo(ventaActual.medioDePago)) {
                if (ventaActual.otros > 0) {
                    totalCobrable -= ventaActual.otros;
                }
                modificarVenta("pagoEfectivo", totalCobrable);
                totalCobrable = 0;
            } else if (!esPagoEnEfectivo(ventaActual.medioDePago) && ventaActual.pagoEfectivo > 0) {
                modificarVenta("pagoEfectivo", 0);
            }


            if (totalCobrable > 0 && pagoConOtrosMedios(ventaActual.medioDePago) && ventaActual.pagoEfectivo === 0) {
                modificarVenta("otros", totalCobrable);
                totalCobrable = 0;
            } else if (!pagoConOtrosMedios(ventaActual.medioDePago) && ventaActual.otros > 0) {
                modificarVenta("otros", 0);
            }
        }, 500);
        return () => clearTimeout(id);
    }, [ventaActual.pagoCredito, subtotal, totalDevuelto, ventaActual.compradorId, ventaActual.otros]);

    // UseEffect para el campo "PAGO EFECTIVO"
    useEffect(() => {
        if (ventaActual.pagoEfectivo === 0) return;
        const id = setTimeout(() => {
            let totalCobrable = Number(subtotal) - Number(totalDevuelto) - ventaActual.pagoNotaCredito;

            if (selectedUser?.identificador !== "9999" && selectedUser?.saldoCredito > 0 && esPagoEnCredito(ventaActual.medioDePago, selectedUser?.saldoCredito)) {
                let totalEnCredito = 0;
                if (selectedUser.saldoCredito > totalCobrable) {
                    totalEnCredito = totalCobrable;
                    totalCobrable = 0;
                }
                else {
                    totalCobrable -= selectedUser.saldoCredito;
                    totalEnCredito = selectedUser.saldoCredito
                }
                if (ventaActual.pagoCredito !== totalEnCredito) {
                    modificarVenta("pagoCredito", totalEnCredito);
                }
            }

            if ((totalCobrable - ventaActual.pagoEfectivo) >= 0) {// No alcanzo
                totalCobrable -= ventaActual.pagoEfectivo;
            } else if ((totalCobrable - ventaActual.pagoEfectivo) < 0) { // sobro
                modificarVenta("pagoEfectivo", totalCobrable);
                totalCobrable = 0;
            }

            if (totalCobrable > 0 && pagoConOtrosMedios(ventaActual.medioDePago)) {
                modificarVenta("otros", totalCobrable);
                totalCobrable = 0;
            } else if (totalCobrable === 0 && ventaActual.otros > 0) {
                modificarVenta("otros", 0);
            }

            if (totalCobrable > 0) {
                modificarVenta("pagoEfectivo", ventaActual.pagoEfectivo + totalCobrable);
            }
        }, 500);

        return () => clearTimeout(id);
    }, [ventaActual.pagoEfectivo])

    useEffect(() => {
        const id = setTimeout(() => {
            let totalCobrable = Number(subtotal) - Number(totalDevuelto) - ventaActual.pagoNotaCredito;

            if(ventaActual.pagoNotaCredito <= 0 && selectedUser?.saldoNotaCredito > 0) {
                    if(selectedUser?.saldoNotaCredito > totalCobrable) {
                        modificarVenta("pagoNotaCredito", totalCobrable);
                        totalCobrable = 0;
                    } else {
                        modificarVenta("pagoNotaCredito", selectedUser?.saldoNotaCredito);
                        totalCobrable -= selectedUser?.saldoNotaCredito;
                    }
            }


            if (selectedUser?.identificador !== "9999" && selectedUser?.saldoCredito > 0 && esPagoEnCredito(ventaActual.medioDePago, selectedUser?.saldoCredito)) {
                let totalEnCredito = 0;
                if (selectedUser.saldoCredito > totalCobrable) {
                    totalEnCredito = totalCobrable;
                    totalCobrable = 0;
                    if (ventaActual.pagoEfectivo > 0) modificarVenta("pagoEfectivo", 0);
                    if (ventaActual.otros > 0) modificarVenta("otros", 0);
                }
                else {
                    totalCobrable -= selectedUser.saldoCredito;
                    totalEnCredito = selectedUser.saldoCredito
                }
                if (ventaActual.pagoCredito !== totalEnCredito) {
                    modificarVenta("pagoCredito", totalEnCredito);
                }
            }

            if (totalCobrable > 0 && esPagoEnEfectivo(ventaActual.medioDePago)) {
                if (ventaActual.otros > 0) {
                    totalCobrable -= ventaActual.otros;
                }
                modificarVenta("pagoEfectivo", totalCobrable);
                totalCobrable = 0;
            } else if (!esPagoEnEfectivo(ventaActual.medioDePago) && ventaActual.pagoEfectivo > 0) {
                modificarVenta("pagoEfectivo", 0);
            }


            if (totalCobrable > 0 && pagoConOtrosMedios(ventaActual.medioDePago) && !esPagoEnEfectivo(ventaActual.medioDePago)) {
                modificarVenta("otros", totalCobrable);
                totalCobrable = 0;
            } else if (!pagoConOtrosMedios(ventaActual.medioDePago) && ventaActual.otros > 0) {
                modificarVenta("otros", 0);
            }
        }, 500)
        return () => clearTimeout(id);
    }, [ventaActual.medioDePago])

    useEffect(() => {
        const id = setTimeout(() => {
            if (selectedUser?.identificador !== "9999" && selectedUser?.saldoNotaCredito) {

                const totalNotaCredito = Number(subtotal) - Number(totalDevuelto);
                if (totalNotaCredito >= selectedUser?.saldoNotaCredito) {
                    modificarVenta("pagoNotaCredito", selectedUser?.saldoNotaCredito)
                } else {
                    modificarVenta("pagoNotaCredito", totalNotaCredito)
                }
            } else {
                modificarVenta("pagoNotaCredito", 0)
            }


            let totalCobrable = Number(subtotal) - Number(totalDevuelto) - ventaActual.pagoNotaCredito

            if (selectedUser?.identificador !== "9999" && selectedUser?.saldoCredito > 0 && esPagoEnCredito(ventaActual.medioDePago, selectedUser?.saldoCredito)) {
                let totalEnCredito = 0;
                if (selectedUser.saldoCredito > totalCobrable) {
                    totalEnCredito = totalCobrable;
                    totalCobrable = 0;
                    if (ventaActual.pagoEfectivo > 0) modificarVenta("pagoEfectivo", 0);
                    if (ventaActual.otros > 0) modificarVenta("otros", 0);
                }
                else {
                    totalCobrable -= selectedUser.saldoCredito;
                    totalEnCredito = selectedUser.saldoCredito
                }
                if (ventaActual.pagoCredito !== totalEnCredito) {
                    modificarVenta("pagoCredito", totalEnCredito);
                }
            }

            if (totalCobrable > 0 && esPagoEnEfectivo(ventaActual.medioDePago)) {
                if (ventaActual.otros > 0) {
                    totalCobrable -= ventaActual.otros;
                }
                modificarVenta("pagoEfectivo", totalCobrable);
                totalCobrable = 0;
            } else if (!esPagoEnEfectivo(ventaActual.medioDePago) && ventaActual.pagoEfectivo > 0) {
                modificarVenta("pagoEfectivo", 0);
            }


            if (totalCobrable > 0 && pagoConOtrosMedios(ventaActual.medioDePago) && !esPagoEnEfectivo(ventaActual.medioDePago)) {
                modificarVenta("otros", totalCobrable);
                totalCobrable = 0;
            } else if (!pagoConOtrosMedios(ventaActual.medioDePago) && ventaActual.otros > 0) {
                modificarVenta("otros", 0);
            }
        }, 500)
        return () => clearTimeout(id);
    }, [subtotal])


    return (
        <div>
            <h5 className={classes.Totaltitle}>Subtotal</h5>
            <h2 name="subtotal" className={classes.TotalTexto}>${subtotal}</h2>
            <h5 className={classes.Totaltitle}>Devoluciones</h5>
            <h2 name="subtotal" className={`${classes.TotalTexto} ${classes.Descuento}`}>${totalDevuelto}</h2>
            {notadCredito && totalFinal > 0 ?
                <>
                    <h5 className={classes.Totaltitle}>Notas de crédito</h5>
                    <h2 name="subtotal" className={`${classes.TotalTexto} ${classes.Descuento}`}>${(notadCredito > totalFinal) ? totalFinal : notadCredito}</h2>
                </>
                : null}

            <div className={classes.Line}></div>
            <h4 className={classes.Totaltitle}>Total</h4>
            <h1 name="total" className={classes.Totalresultado}>
                {notadCredito && notadCredito > totalFinal
                    ? '0'
                    : totalFinal < 0
                        ? totalFinal.toFixed(2)
                        : notadCredito
                            ? (totalFinal - notadCredito).toFixed(2)
                            : totalFinal.toFixed(2)}
            </h1>

            {/**-------------------------- USUARIO ------------------------ */}
            <Autocomplete className={classes.formControl}
                id='combo-box-demo'
                options={users}
                isOptionEqualToValue={(option, value) => option._id === value._id}
                getOptionLabel={(option) => option.nombreCompleto}
                value={selectedUser}
                inputValue={userSearchInput}
                onInputChange={(_, newInputValue) => {
                    setUserSearchInput(newInputValue);
                }}
                onChange={(_, value) => {
                    if (value) {
                        modificarVenta("compradorId", value.identificador, value.saldoCredito);
                        if (value?.identificador !== "9999" && value?.saldoNotaCredito) {
                            const totalNotaCredito = Number(subtotal) - Number(totalDevuelto);
                            if (totalNotaCredito >= value?.saldoNotaCredito) {
                                modificarVenta("pagoNotaCredito", value?.saldoNotaCredito)
                            } else {
                                modificarVenta("pagoNotaCredito", totalNotaCredito)
                                
                            }
                        } else {
                            modificarVenta("pagoNotaCredito", 0)
                        }
                    }
                }}
                renderOption={(props, option) => {
                    return <li {...props} key={option._id}>{option.nombreCompleto}</li>
                }}
                renderInput={(params) => (<TextField   {...params} label='Elija un cliente' variant='outlined' />
                )}
            />

            {/*---------------------- MEDIO DE PAGO ---------------------- */}
            <FormControl variant='outlined' className={classes.formControl}>
                <InputLabel >Medio de pago</InputLabel>
                <Select
                    variant="standard"
                    native
                    value={ventaActual.medioDePago}
                    onChange={e => {
                        modificarVenta('medioDePago', e.target.value, selectedUser?.saldoCredito)
                    }}
                    label='Medio De Pago'
                    inputProps={{ name: 'medioDePago', id: 'medioDePago' }}>

                    <option value={MEDIO_DE_PAGO.NINGUNO}>Ninguno</option>
                    {ventaActual.compradorId !== '9999' && < option value={MEDIO_DE_PAGO.CUENTA_CORRIENTE}>Cuenta Corriente</option>}
                    <option value={MEDIO_DE_PAGO.EFECTIVO}>Efectivo</option>
                    {ventaActual.compradorId !== '9999' && <option value={MEDIO_DE_PAGO.CREDITO_Y_EFECTIVO}>Cuenta Corriente + Efectivo</option>}
                    <option value={MEDIO_DE_PAGO.TC}>Tarjeta Credito</option>
                    <option value={MEDIO_DE_PAGO.TD}>Tarjeta Debito</option>
                    <option value={MEDIO_DE_PAGO.EFECTIVO_Y_TC}>Efectivo + TC</option>
                    <option value={MEDIO_DE_PAGO.EFECTIVO_Y_TD}>Efectivo + TD</option>
                    {ventaActual.compradorId !== '9999' && <option value={MEDIO_DE_PAGO.CUENTA_CORRIENTE_Y_TC}>Cuenta C. + TC</option>}
                    {ventaActual.compradorId !== '9999' && <option value={MEDIO_DE_PAGO.CUENTA_CORRIENTE_Y_TD}>Cuenta C. + TD</option>}
                    <option value={MEDIO_DE_PAGO.EFECTIVO_Y_TRANSFERENCIA}>Efectivo + Transferencia</option>
                    {ventaActual.compradorId !== '9999' && <option value={MEDIO_DE_PAGO.CUENTA_CORRIENTE_Y_TRANSFERENCIA}>Cuenta C. + Transferencia</option>}
                    <option value={MEDIO_DE_PAGO.TRANSFERENCIA}>Transferencia</option>

                </Select>
            </FormControl>
            {/*---------------------- ESTADO ---------------------- */}
            <FormControl variant='outlined' className={classes.formControl}>
                <InputLabel >Estado</InputLabel>
                <Select
                    variant="standard"
                    native
                    value={ventaActual.estado}
                    onChange={e => {
                        modificarVenta("estado", e.target.value);
                    }}
                    label='estado'
                    inputProps={{
                        name: 'estado',
                        id: 'estado',
                    }}>
                    <option aria-label='Ninguno' defaultValue value='' />
                    <option value={PEDIDO_ESTADO.PENDIENTE}>Pendiente</option>
                    <option value={PEDIDO_ESTADO.CONFIRMADO}>Confirmado</option>
                    <option value={PEDIDO_ESTADO.PRODUCCION}>Produccion</option>
                    <option value={PEDIDO_ESTADO.LISTO}>Listo a entregar</option>
                    <option value={PEDIDO_ESTADO.ENTREGADO}>Entregado</option>
                </Select>
            </FormControl>
            {
                /*---------------------- EFECTIVO ---------------------- */
                esPagoEnEfectivo(ventaActual.medioDePago) ?
                    <TextField className={classes.formControl}
                        id="efectivo"
                        name="efectivo"
                        type="text"
                        label="Monto en efectivo"
                        variant="outlined"
                        value={ventaActual.pagoEfectivo}
                        onChange={e => {
                            const monto = Number(e.target.value);
                            if (!isNaN(monto)) modificarVenta("pagoEfectivo", monto);
                        }}
                    /> : null
            }
            {
                /*---------------------- CREDITO ---------------------- */
                esPagoEnCredito(ventaActual.medioDePago, selectedUser?.saldoCredito) ?
                    (<TextField className={classes.formControl}
                        id="credito"
                        name="credito"
                        type="text"
                        label="Pago en crédito"
                        variant="outlined"
                        value={ventaActual.pagoCredito}
                        onChange={e => {
                            const monto = Number(e.target.value);
                            if (!isNaN(monto)) {
                                modificarVenta("pagoCredito", monto);
                            }
                        }}
                    />) : null
            }
            {
                /*---------------------- OTROS ---------------------- */
                pagoConOtrosMedios(ventaActual.medioDePago) ?
                    <TextField className={classes.formControl}
                        id="otros"
                        name="otros"
                        type="text"
                        label="Otros medios de pago"
                        variant="outlined"
                        helperText={`${recargo ? 'Monto final en TC  $' + (ventaActual.otros * (1 + recargo / 100)).toFixed(2) : ''}`}
                        value={ventaActual.otros}
                        onChange={e => {
                            const monto = Number(e.target.value);
                            if (!isNaN(monto)) {
                                modificarVenta("otros", monto)
                            }
                        }}
                    /> : null
            }
            {
                /*---------------------- RECARGO ---------------------- */
                incluyeRecargo(ventaActual.medioDePago) ?
                    <TextField className={classes.formControl}
                        id="recargo"
                        name="recargo"
                        type="text"
                        label="% de recargo"
                        variant="outlined"
                        value={recargo}
                        onChange={e => {
                            try {
                                let value = parseFloat(e.target.value);
                                if (!isNaN(value)) setRecargo(value)
                            } catch (error) {
                                setRecargo(0);
                            }
                        }
                        }
                    /> : null
            }
            {
                /*---------------------- PAGO NOTA CREDITO ---------------------- */
                ventaActual.medioDePago !== MEDIO_DE_PAGO.NINGUNO &&
                <TextField className={classes.formControl}
                    id="pagoNotaCredito"
                    name="pagoNotaCredito"
                    type="text"
                    disabled={ventaActual.compradorId !== '9999'}
                    label="Pago con nota de credito"
                    variant="outlined"
                    value={ventaActual.pagoNotaCredito}
                    onChange={e => {
                        const monto = Number(e.target.value);
                        if (!isNaN(monto)) {
                            modificarVenta("pagoNotaCredito", monto);
                        }
                    }
                    }
                />
            }
            {/*---------------------- OBSERVACIONES ---------------------- */}
            <TextField className={classes.formControl}
                id="observaciones"
                name="observaciones"
                type="text"
                multiline
                label="Observaciones"
                variant="outlined"
                value={ventaActual.observaciones}
                onChange={e => { modificarVenta("observaciones", e.target.value) }}
            />
        </div >
    );
}

Totales.propTypes = {
    setRecalcula: Proptypes.func,
    selectedUser: Proptypes.object,
    notadCredito: Proptypes.number,
    recalculo: Proptypes.bool,
}

export default Totales;